// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1r04idpf{inset:0}._18m91wug{overflow-y:auto}
._1pbybfng{z-index:500}
._bfhk1j28{background-color:transparent}
._bfhk705f{background-color:var(--_10avjlk)}
._kqsw1n9t{position:fixed}
._lcxv1wug{pointer-events:auto}
._lcxvglyw{pointer-events:none}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/blanket/dist/esm/blanket.compiled.css"],"names":[],"mappings":";AACA,WAAW,OAAO,CAAC,WAAW,eAAe;AAC7C,WAAW,WAAW;AACtB,WAAW,4BAA4B;AACvC,WAAW,gCAAgC;AAC3C,WAAW,cAAc;AACzB,WAAW,mBAAmB;AAC9B,WAAW,mBAAmB","sourcesContent":["\n._1r04idpf{inset:0}._18m91wug{overflow-y:auto}\n._1pbybfng{z-index:500}\n._bfhk1j28{background-color:transparent}\n._bfhk705f{background-color:var(--_10avjlk)}\n._kqsw1n9t{position:fixed}\n._lcxv1wug{pointer-events:auto}\n._lcxvglyw{pointer-events:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
